import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getCouncilMailLogs } from 'apis/councils.api';

const useGetCouncilMailLogs = (councilId, params, conds) => {
  const { data: councilMailLogsData, ...rest } = useQuery(
    ['councilMailLogs', councilId, params],
    () => getCouncilMailLogs(councilId, params),
    {
      ...conds,
    }
  );
  const councilMailLogs = useMemo(() => councilMailLogsData?.data ?? [], [councilMailLogsData]);

  return {
    data: councilMailLogs,
    rest,
  };
};

export default useGetCouncilMailLogs;
